import React from "react";
import Clear from '@material-ui/icons/Clear';
import { withTranslation } from "react-i18next";
import { debounce } from 'lodash';
import { Checkbox, IconButton } from '@workboard/wobo-ui';
import styled from 'styled-components';
import GoalServices from "../../../../services/goal.services";

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
	padding: 0;
  }
  input{
    display: inline-block !important;
  }
  .MuiFormControlLabel-label{
	font-size: 13px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;
const StyledIconButton = styled(IconButton)`
    width: 21px;
    height: 21px;
    svg {
      width: 24px;
      height: 24px;
    }
    &.MuiButtonBase-root{
        vertical-align: top;
    }
`;

const SEARCH_DEBOUNCE_MS = 300;
class ProgressCalculationComp extends React.Component {
	constructor(props) {
		super(props);
		const {t} = this.props;
		let permission = this.props.item && this.props.item.permission  && this.props.item.permission.length > 0 ? this.props.item.permission.split(",").map(Number) :this.props.item && this.props.item.id ? this.props.item.permission : this.props.goalDetails.type == 1 ? (this.props.goalDetails.default_permission &&
			Object.keys(this.props.goalDetails.default_permission).length > 0 ? this.props.goalDetails.default_permission.split(",").map(Number) : [8]) : [10];
		this.state = {
			filter: {
				Team: [],
				BizGroups: []
			},
			_isTeamMounted: false,
			permissonEn: false,
			subPermissonEn: false,
			krPermissionText:
				this.props.item &&
					this.props.item.permission &&
					this.props.item.permission.length > 0
					? this.props.goalDetails &&
						this.props.goalDetails.permission.length > 2
						? t("Custom view permissions")
						: t("Organization can view")
					: this.props.goalDetails.type == 1
						? t("Only team can view")
						: t("Only owner can view"),
			permissionstate:
				this.props.item &&
					this.props.item.permission &&
					Object.keys(this.props.item.permission).length > 0
					? this.props.item.permission.split(",").map(Number)
					: this.props.item && this.props.item.id ? this.props.item.permission : this.props.goalDetails.type == 1 ? (this.props.goalDetails.default_permission &&
					Object.keys(this.props.goalDetails.default_permission).length > 0 ? this.props.goalDetails.default_permission.split(",").map(Number) : [8]) : [10],
			teamPermissionSelected:
				this.props.item &&
					this.props.item.permission_teams &&
					Object.keys(this.props.item.permission_teams).length > 0
					? this.props.item.permission_teams
					: 
					this.props.goalDetails.type == 1 &&
					this.props.goalDetails.default_permission_teams &&
					Object.keys(this.props.goalDetails.default_permission_teams).length > 0 &&
					((permission && permission).length > 0 && (permission.includes(8) ||
					permission.includes(1) || permission.includes(2) || permission.includes(10)
					|| (this.props.goalDetails.all_metrics == 0 && permission.includes(7))))
					? this.props.goalDetails.default_permission_teams : [],
			bizPermissionSelected: this.props.item && this.props.item.permission_biz &&
				Object.keys(this.props.item.permission_biz).length > 0
				? this.props.item.permission_biz
				: [],
			teamSearchVal: "",
			hide: this.props.hide && this.props.hide != undefined ? true : false,
			setreverse: ''
		};
		this.GoalServices = new GoalServices();
		this.toggelePermission = this.toggelePermission.bind(this);
		this.handlePersmissionChange = this.handlePersmissionChange.bind(this);
		this.filterTeamFunctions = this.filterTeamFunctions.bind(this);
		this.toggeleSubPermission = this.toggeleSubPermission.bind(this);
		this.handleTeamBizChange = this.handleTeamBizChange.bind(this);
		this.clickEvent = this.clickEvent.bind(this);
		this.permissionHead = this.permissionHead.bind(this);
		this.handleKeydownevent = this.handleKeydownevent.bind(this);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.clickEvent, false);
		this.permissionHead();
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.item.permission_biz !== this.props.item.permission_biz && this.props.item.permission_biz !== this.state.bizPermissionSelected){
			this.setState({
				bizPermissionSelected: this.props.item.permission_biz ? this.props.item.permission_biz : []
			}, () => {
				let permissions = this.state.permissionstate;
				let newArr = this.props.goalDetails.type == 1 ? [7] : [];
				if(this.state.bizPermissionSelected.length > 0){
					if(permissions.includes(8)){
						newArr = permissions.filter(a => a !== 8);
					}
				}else{
					if(!this.state.teamPermissionSelected.length > 0){
						newArr = [...permissions, 8];
					}
				}
				this.setState({
					permissionstate: newArr,
				}, () => {
					this.permissionHead();
					this.props.permissionData(this.state.permissionstate);
				});
			})
		}
	}

	clickEvent(e) {
		let that = this;
		let enableObj = {};
		let filterObj = {
			filter: {}
		};

		if (
			!$(".aEPermissionList").is(e.target) &&
			$(".aEPermissionList").has(e.target).length === 0
		) {
			if(this.state.permissonEn || this.state.subPermissonEn){
				this.setState({
					permissonEn: false,
					subPermissonEn: false,
					filter: {
						...this.state.filter,
						Team: [],
						BizGroups: []
					}
				});
			}
			
		}
	}
	toggelePermission() {

		this.setState({
			permissonEn: true
		});

		if(!this.props.comingFromTest){
			var scrollTop = $('.aEGoalContent').scrollTop();
			var topOffset = $(".dropdown").offset().top;
			var relativeOffset = topOffset-scrollTop;
			var windowHeight = $('.aEGoalContent').height();
			if(relativeOffset > windowHeight/2){
				this.setState({
					setreverse: 'reverse'
				})
			}
			else{
				this.setState({
					setreverse: ''
				})
			}
		}
	}

	toggeleSubPermission() {
		this.setState({
			subPermissonEn: true,
			permissonEn: true
		});
	}

	filterTeamFunctions = debounce((event) => {
		event.preventDefault();
		let input, filter;
		let _this = this;
		input = document.getElementById("TeamSearch");
		filter = input.value.toLowerCase();
		filter[0] === " " ? filter[0].replace(" ", "") : filter;
		filter[filter.length - 1] === " "
			? filter[filter.length - 1].replace(" ", "")
			: filter;
		this.setState(
			{
				filter: {
					..._this.state.filter,
					Team: [],
					BizGroups: []
				},
				teamSearchVal: filter
			},
			() => {
				if (filter.length > 1) {
					this.GoalServices.searchPermTeamsAndBiz({ term: filter }).then(function (
						response
					) {
						if (response.data) {
							_this.setState({
								filter: {
									..._this.state.filter,
									Team:
										filter === _this.state.teamSearchVal ? response.data.teams : [],
									BizGroups: filter === _this.state.teamSearchVal ? response.data.bizGroups : [],
								}
							});
						}
					});
				}
			}
		);
	}, SEARCH_DEBOUNCE_MS);

	selectTeam(event, valTeam) {
		let _this = this;
		_this.setState({
			teamSearchText: valTeam.name,
			for_0: valTeam.id,
			subPermissonEn: false
		});
	}

	handlePersmissionChange(event, item, strPermissionText) {
		const {t} = this.props;
		event.stopPropagation();
		const { permission, permissionstate, teamPermissionSelected } = this.state;
		let newArr = this.props.goalDetails.type == 1 ? [7] : [];
		let that = this;
		if (!permissionstate.includes(item)) {
			newArr = [...permissionstate, item];
		} else {
			newArr = permissionstate.filter(a => a !== item);
			if (newArr.length == 0) {
				newArr = this.props.goalDetails.type == 1 ? [7] : newArr;
			}
		}
		// if(teamPermissionSelected.length == 0 && permissionstate.includes(7) ){
		// 	newArr = permissionstate.filter(a => a !== 7);
		// }
		if(this.props.goalDetails.type == 1){
			if (item == 8) {
				if (newArr.includes(1)) {
					newArr = newArr.filter(i => i != 1);
				}
				if (newArr.includes(2)) {
					newArr = newArr.filter(i => i != 2);
				}
			}
			if (item == 2 || item == 1) {
				if (newArr.includes(8)) {
					newArr = newArr.filter(i => i != 8);
				}
			}

			if (newArr.includes(8)  && teamPermissionSelected.length > 0 ) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(8)) {
				that.setState({ krPermissionText: t("Organization can view") });
			} else if (newArr.includes(1) && newArr.includes(2)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(1) && teamPermissionSelected.length > 0) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(1)) {
				that.setState({ krPermissionText: t("Management can view") });
			} else if (newArr.includes(2) && teamPermissionSelected.length > 0) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(2)) {
				that.setState({ krPermissionText: t("All reports to owner can view") });
			} else {
				if (teamPermissionSelected.length > 0) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else {
					that.setState({
						krPermissionText:
							this.props.goalDetails.type == 1
								? t("Only team can view")
								: t("Only owner can view")
					});
				}
			}

		} 

		if(this.props.goalDetails.type == 2){
			if (item == 8) {
				if (newArr.includes(10)) {
					newArr = newArr.filter(i => i != 10);
				}
				if (newArr.includes(2)) {
					newArr = newArr.filter(i => i != 2);
				}
			}
			if (item == 2 || item == 10) {
				if (newArr.includes(8)) {
					newArr = newArr.filter(i => i != 8);
				}
			}

			if (newArr.includes(8)  && teamPermissionSelected.length > 0 ) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(8)) {
				that.setState({ krPermissionText: t("Organization can view") });
			} else if (newArr.includes(10) && newArr.includes(2)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(10) && teamPermissionSelected.length > 0) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(10)) {
				that.setState({ krPermissionText: t("Management can view") });
			} else if (newArr.includes(2) && teamPermissionSelected.length > 0) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (newArr.includes(2)) {
				that.setState({ krPermissionText: t("All reports to owner can view") });
			} else {
				if (teamPermissionSelected.length > 0) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else {
					that.setState({
						krPermissionText:
							this.props.goalDetails.type == 1
								? t("Only team can view")
								: t("Only owner can view")
					});
				}
			}
		} 
		//this.permissionHead();
		
		setTimeout(() => {
			that.setState({
				permissionstate: newArr,
				permissonEn: true
			}, () => {
				this.props.permissionData(this.state.permissionstate);
			});
			
		}, 0);
	}

	handleRemoveTeam () {
        const focusableRemoveElements = document.querySelectorAll(
            '[id^="removeTeamBtn"]'
          )
          const focusableRemoveArr = Array.prototype.slice.call(focusableRemoveElements);
          const firstRemoveBtn = focusableRemoveArr[0];
          if (firstRemoveBtn) {
            firstRemoveBtn?.focus();
          }
          else {
			document.getElementById("view-permission-dropdownId").focus();
          }
    }

	handleTeamBizChange(event, selectedGoal, type) {
		event.stopPropagation();
		let result = [], bizResult = [];
		let permissions = this.state.permissionstate;
		let that = this;
		let existingState;
		if(type === 'biz'){
			existingState = this.state.bizPermissionSelected;
			if (existingState.find(val => val.id == selectedGoal.id)) {
				bizResult = existingState.filter(eachVal => eachVal.id != selectedGoal.id);
			} else {
				bizResult = [...existingState, selectedGoal];
			}
			result = this.state.teamPermissionSelected;
		} else if (type === 'team'){
			existingState = this.state.teamPermissionSelected;

			if (existingState.find(val => val.id == selectedGoal.id)) {
				result = existingState.filter(eachVal => eachVal.id != selectedGoal.id);
			} else {
				result = [...existingState, selectedGoal];
			}
			bizResult = this.state.bizPermissionSelected;
		}
		
		
		let item = 8 ;
		let newArr = this.props.goalDetails.type == 1 ? [7] : [];
		if (!permissions.includes(item)) {
			newArr = [...permissions, item];
		} else {
			newArr = permissions.filter(a => a !== item);
		}
		if (newArr.includes(8)) {
			newArr = newArr.filter(i => i != 8);
		}
		// if(this.props.goalDetails.type == 1){
		// 	if (permissions.includes(8) && (result.length > 0 || bizResult.length > 0)) {
		// 		that.setState({ krPermissionText: "Custom view permissions" });
		// 	} else if (permissions.includes(1) && (result.length > 0 || bizResult.length > 0)) {
		// 		that.setState({ krPermissionText: "Custom view permissions" });
		// 	} else if (permissions.includes(2) && (result.length > 0 || bizResult.length > 0)) {
		// 		that.setState({ krPermissionText: "Custom view permissions" });
		// 	} else {
		// 		if ((result.length > 1 || bizResult.length > 1)) {
		// 			that.setState({ krPermissionText: "Custom view permissions" });
		// 		} else if ((result.length > 0 || bizResult.length > 0) && that.props.goalDetails.type == 2 ) {
		// 			that.setState({ krPermissionText: "Custom view permissions" });
		// 		}  else if (permissions.includes(8)) {
		// 			that.setState({ krPermissionText: "Organization can view" });
		// 		} else if (permissions.includes(1)) {
		// 			that.setState({ krPermissionText: "Management can view" });
		// 		} else if (permissions.includes(2)) {
		// 			that.setState({
		// 				krPermissionText: "All reports to owner can view"
		// 			});
		// 		} else if ((result.length > 0 || bizResult.length > 0) && that.props.goalDetails.type == 1 ) {
		// 			that.setState({ krPermissionText: "Custom view permissions" });
		// 		} 
		// 		// else if(result.length == 0){
		// 		// 	//newArr = newArr.filter(i => i == 8);
				
		// 		// } 
		// 		else {
		// 			that.setState({
		// 				krPermissionText:
		// 					that.props.goalDetails.type == 1
		// 						? "Only team can view"
		// 						: "Only owner can view"
		// 			});
		// 		}
		// 	}
		// }

		// if(this.props.goalDetails.type == 2){
		// 	if (permissions.includes(8) && (result.length > 0 || bizResult.length > 0)) {
		// 		that.setState({ krPermissionText: "Custom view permissions" });
		// 	} else if (permissions.includes(10) && (result.length > 0 || bizResult.length > 0)) {
		// 		that.setState({ krPermissionText: "Custom view permissions" });
		// 	} else if (permissions.includes(2) && (result.length > 0 || bizResult.length > 0)) {
		// 		that.setState({ krPermissionText: "Custom view permissions" });
		// 	} else {
		// 		if ((result.length > 1 || bizResult.length > 1)) {
		// 			that.setState({ krPermissionText: "Custom view permissions" });
		// 		} else if ((result.length > 0 || bizResult.length > 0) && that.props.goalDetails.type == 2 ) {
		// 			that.setState({ krPermissionText: "Custom view permissions" });
		// 		}  else if (permissions.includes(8)) {
		// 			that.setState({ krPermissionText: "Organization can view" });
		// 		} else if (permissions.includes(10)) {
		// 			that.setState({ krPermissionText: "Management can view" });
		// 		} else if (permissions.includes(2)) {
		// 			that.setState({
		// 				krPermissionText: "All reports to owner can view"
		// 			});
		// 		} else if ((result.length > 0 || bizResult.length > 0) && that.props.goalDetails.type == 1 ) {
		// 			that.setState({ krPermissionText: "Custom view permissions" });
		// 		}  else {
		// 			that.setState({
		// 				krPermissionText:
		// 					that.props.goalDetails.type == 1
		// 						? "Only team can view"
		// 						: "Only owner can view"
		// 			});
		// 		}
		// 	}
		// }
	//this.permissionHead();

		setTimeout(() => {
			that.setState({
				teamPermissionSelected: result,
				bizPermissionSelected: bizResult,
				permissionstate: newArr,
			}, () => {
				this.permissionHead();
				this.props.teamPermissionData(this.state.teamPermissionSelected);
				this.props.bizPermissionData(this.state.bizPermissionSelected);
				this.props.permissionData(this.state.permissionstate);
				this.handleRemoveTeam();
			});
		}, 0);
	}

	permissionHead() {
		const {t} = this.props;
		const { teamPermissionSelected, bizPermissionSelected } = this.state;
		//let existingState = this.state.teamPermissionSelected;
		let permissions = this.state.permissionstate;
		let that = this;

		if(this.props.goalDetails.type == 1){
			if (permissions.includes(8) && (teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (permissions.includes(1) && (teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (permissions.includes(2) && (teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else {
				if ((teamPermissionSelected.length > 1 || bizPermissionSelected.length > 1)) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else if ((teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0) && that.props.goalDetails.type == 2 ) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else if (permissions.includes(8)) {
					that.setState({ krPermissionText: t("Organization can view") });
				} else if (permissions.includes(1) && permissions.includes(2)) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else if (permissions.includes(1)) {
					that.setState({ krPermissionText: t("Management can view") });
				} else if (permissions.includes(2)) {
					that.setState({
						krPermissionText: t("All reports to owner can view")
					});
				} else if ((teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0) && that.props.goalDetails.type == 1 ) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else {
					that.setState({
						krPermissionText:
							that.props.goalDetails.type == 1
								? t("Only team can view")
								: t("Only owner can view")
					});
				}
			}
		}

		if(this.props.goalDetails.type == 2){
			if (permissions.includes(8) && (teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (permissions.includes(10) && (teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else if (permissions.includes(2) && (teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0)) {
				that.setState({ krPermissionText: t("Custom view permissions") });
			} else {
				if ((teamPermissionSelected.length > 1 || bizPermissionSelected.length > 1)) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				}  else if ((teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0) && that.props.goalDetails.type == 2 ) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				}  else if (permissions.includes(8)) {
					that.setState({ krPermissionText: t("Organization can view") });
				} else if (permissions.includes(10) && permissions.includes(2)) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else if (permissions.includes(10)) {
					that.setState({ krPermissionText: t("Management can view") });
				} else if (permissions.includes(2)) {
					that.setState({
						krPermissionText: t("All reports to owner can view")
					});
				} else if ((teamPermissionSelected.length > 0 || bizPermissionSelected.length > 0) && that.props.goalDetails.type == 1 ) {
					that.setState({ krPermissionText: t("Custom view permissions") });
				} else {
					that.setState({
						krPermissionText:
							that.props.goalDetails.type == 1
								? t("Only team can view")
								: t("Only owner can view")
					});
				}
			}
		}
	}
	handleKeydownevent(e){
		if(e.key === "Enter" || (e.key === " " && e.target.id != "TeamSearch") ){
			e.preventDefault();
			this.toggelePermission()
		} else if(e.key === "Tab"){
			this.setState({
				permissonEn: false
			});
		}else if(e.key === "Escape"){
			e.stopPropagation();
			this.setState({
				permissonEn: false
			});
			document.getElementById("view-permission-dropdownId").focus();
		}
	}
	render() {
		const hideApplyCheckbox = this.props.hideApplyCheckbox || false;
		const { t } = this.props;
		let isExcluded =this.props.Exclude ? true : false;
		let disabledOrgView = false;
		if(this.props.okr_disabled_org_perm == undefined || this.props.okr_disabled_org_perm == 0 || this.props.goalDetails.type == 1){
			disabledOrgView = true;
		}
		const placeHolderText = t('Search for teams or biz groups')
		return (
			<div className="inLineBlk dropdown">
				<div
					className="aEPermissionList perMissionTeam dropdown-toggle"
					data-testid="permission-test"
					onClick={this.toggelePermission}
					tabIndex={0}
					onKeyDown={e => this.handleKeydownevent(e)}
					role="button"
					id="view-permission-dropdownId"
				>
					<div className="aEPermissionSearchdiv">
						<div className="per-text-arrow truncate" data-testid="per-text-arrow">
							{this.state.krPermissionText}
						</div>
						<div className="arrowDown " />
					</div>
					{this.state.permissonEn && (
						<div id="myAlign" className={"dropdown-alignment "+this.state.setreverse + (disabledOrgView ? "" : " disabledOrgView")} >
							<div
								className={
									this.props.goalDetails.type == 1
										? "permissionContent team-permission "
										: "permissionContent  personal-permission "
								}
							>
								{ 
								disabledOrgView ? 
									<div className="myAlign organization" data-testid="myAlign">
										<input
											id="per8"
											className="defaultUnCheck alignCheck inLineBlk"
											onChange={evnt =>
												this.handlePersmissionChange(
													evnt,
													8,
													"Organization can view"
												)
											}
											type="checkbox"
											checked={
												this.state.permissionstate.length > 0 &&
													this.state.permissionstate.find(e => e == 8)
													? true
													: false
											}
										/>
										<label htmlFor="per8" data-testid="organization-can-view"/>
										<span className="alignOdjtex" >{t('Organization can view ')}</span>
									</div>
									: ""
								}
								
								{this.props.goalDetails.type == 1 && (
								<div className="myAlign" data-testid="myAlign">
									<input
										id="per1"
										className="defaultUnCheck alignCheck inLineBlk"
										onChange={evnt =>
											this.handlePersmissionChange(
												evnt,
												1,
												"Management can view"
											)
										}
										type="checkbox"
										checked={
											this.state.permissionstate.length > 0 &&
												this.state.permissionstate.find(e => e == 1)
												? true
												: false
										}
									/>
									<label htmlFor="per1" data-testid="management-can-view"/>
									<span className="alignOdjtex">{t('Management can view')}</span>
								</div>
								)}
								{this.props.goalDetails.type == 2 && (
								<div className="myAlign" data-testid="myAlign">
									<input
										id="per10"
										className="defaultUnCheck alignCheck inLineBlk"
										onChange={evnt =>
											this.handlePersmissionChange(
												evnt,
												10,
												"Management can view"
											)
										}
										type="checkbox"
										checked={
											this.state.permissionstate.length > 0 &&
												this.state.permissionstate.find(e => e == 10)
												? true
												: false
										}
									/>
									<label htmlFor="per10" data-testid="management-can-view"/>
									<span className="alignOdjtex">{t('Management can view')}</span>
								</div>
								)}
								{this.props.goalDetails.type == 1 && (
									<div className="myAlign" data-testid="myAlign">
										<input
											id="per2"
											className="defaultUnCheck alignCheck inLineBlk"
											onChange={evnt =>
												this.handlePersmissionChange(
													evnt,
													2,
													"All reports to owner can view"
												)
											}
											type="checkbox"
											checked={
												this.state.permissionstate.length > 0 &&
													this.state.permissionstate.find(e => e == 2)
													? true
													: false
											}
										/>
										<label htmlFor="per2" data-testid="all-owner-can-view"/>
										<div className="inLineBlk alignOdjList ">
											<div className="alignOdjtex" >
												{t('All reports to owner can view')}{" "}
											</div>
										</div>
									</div>
								)}
							</div>
							<div
								className="aESubPermissionList objPermissionSearch"
								data-testid="toggle-search-permission"
								onClick={this.toggeleSubPermission}
								style={{height:'auto'}}
							>
								<div className="aESubPermissionSearchdiv" title={placeHolderText.length>30 && placeHolderText}>
									{placeHolderText.length <= 30 ? placeHolderText : placeHolderText.split('').slice(0,27).join('')+'...'}
                </div>
								{this.state.subPermissonEn && (
									<div id="myAlign" data-testid="myAlign" className="dropdown-alignment ">
										<input
											type="text"
											placeholder={placeHolderText.length <= 40 ? placeHolderText : placeHolderText.split('').slice(0,37).join('')+'...'}
											id="TeamSearch"
											className="objSubPermissionSearch otherTeamPersmission"
											data-testid="team-search-bar"
											onChange={event => this.filterTeamFunctions(event)}
											autoFocus={true}
										/>
										<div className="teamPermission">
											{this.state.filter &&
												this.state.filter.Team && this.state.filter.Team.length > 0 &&
												<>
												<div className="myAlign category"  style={{fontWeight: 700, fontSize: "14px", lineHeight: "20px", color: "#000000"}}>
													{t('Teams')}
												</div>
												{this.state.filter.Team.map(valTeam => (
													<div className="permissionContents" data-testid="custom-permission-item" key={valTeam.id}>
														<div className="myAlign" data-testid="myAlign">
															<input
																id={valTeam.id + "per_" + valTeam.id}
																className="defaultUnCheck alignCheck singleLine"
																onClick={e => this.handleTeamBizChange(e, valTeam, 'team')}
																type="checkbox"
																defaultChecked={
																	this.state.teamPermissionSelected.find(
																		val => val.id == valTeam.id
																	)
																		? true
																		: false
																}
															/>
															<label
																htmlFor={valTeam.id + "per_" + valTeam.id}
															/>
															<div
																className="handCur truncate singleLine"
																onClick={e => {
																	this.selectTeam(e, valTeam);
																}}
															>
																{valTeam.name}
															</div>
														</div>
													</div>
												))}
											</>
											}
											{this.state.filter &&
												this.state.filter.BizGroups && this.state.filter.BizGroups.length > 0 &&
												<>
												<div className="myAlign category" style={{fontWeight: 700, fontSize: "14px", lineHeight: "20px",color: "#000000"}}>
													{t('Biz Groups')}
												</div>
												{this.state.filter.BizGroups.map(valTeam => (
													<div className="permissionContents" data-testid="custom-permission-biz" key={`${valTeam.id}_biz`}>
														<div className="myAlign" data-testid="myAlign">
															<input
																id={valTeam.id + "per_" + valTeam.id + '_1'}
																className="defaultUnCheck alignCheck singleLine"
																onClick={e => this.handleTeamBizChange(e, valTeam, 'biz')}
																type="checkbox"
																defaultChecked={
																	this.state.bizPermissionSelected.find(
																		val => val.id == valTeam.id
																	)
																		? true
																		: false
																}
															/>
															<label
																htmlFor={valTeam.id + "per_" + valTeam.id + '_1'}
															/>
															<div
																className="handCur truncate singleLine"
																onClick={e => {
																	this.selectTeam(e, valTeam);
																}}
															>
																{valTeam.name}
															</div>
														</div>
													</div>
												))}
											</>
											}
										</div>
									</div>
								)}
							</div>
						</div>
					)}
				</div>

				{this.state.hide && (
					<div className="ApplyPermission inLineBlk">
						{
							hideApplyCheckbox ? 
							<React.Fragment>
								<label htmlFor="ApperLabel" />
								<span>{'(' + t('Apply to objective and key results') + ')'}</span> 
							</React.Fragment>
							:
							<React.Fragment>
								<StyledCheckbox
									id="ApperLabel"
									className={
										"defaultUnCheck alignCheck inLineBlk" + this.props.Exclude
											? ""
											: ""
									}
									label={t('Apply to objective and key results')}
									ref={node => (this.dsExcludeProg = node)}
									isChecked={isExcluded}
									onChange={this.props.handleExcludeChange}
								/>
							</React.Fragment>
						}
					</div>
				)}

				<div className="permission-selected-team-wrapper selectedTeamList">
					{this.state.teamPermissionSelected.length > 0 && (
						<div className="selectedObj">{t('Selected team')}(s):</div>
					)}
					{this.state.teamPermissionSelected &&
						this.state.teamPermissionSelected.map(val => (
							<div className="selectedObj" data-testid="selected-team" key={val.id}>
								<div className="selectedMyAlign selWsTeamHigh">
									<div className="inLineBlk alignOdjList">
										<div className="alignObjInfo" id={`selected-team-${val.id}`}>
											<span>{`${val.name} `}</span>
										</div>
									</div>
									<StyledIconButton
										aria-label='Remove'
										aria-describedby={`selected-team-${val.id}`}
										id={`removeTeamBtn${val.id}`}
										onClick={e => this.handleTeamBizChange(e, val, 'team')}
									>
										<Clear />
									</StyledIconButton>
								</div>
							</div>
						))}
						{this.state.bizPermissionSelected.length > 0 && (
						<div className="selectedObj">{t('Selected biz group')}(s):</div>
					)}
					{this.state.bizPermissionSelected &&
						this.state.bizPermissionSelected.map(val => (
							<div className="selectedObj" data-testid="seleted-group-biz" key={val.id}>
								<div className="selectedMyAlign selWsTeamHigh">
									<div className="inLineBlk alignOdjList">
										<div className="alignObjInfo">
											<span>{`${val.name} `}</span>
										</div>
									</div>
									<div
										className="outline-close-24px"
										onClick={e => this.handleTeamBizChange(e, val, 'biz')}
									/>
								</div>
							</div>
						))}
				</div>
			</div>
		);
	}
}

export default withTranslation()(ProgressCalculationComp)